import { Injectable } from '@angular/core';
import { BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';

import { DataItem } from 'models/data.model';
import { ModalGroup, ModalContentType, Modal } from 'models/multimodal.model';
import { MultimodalComponent } from 'shared/multimodal/multimodal.component';

import { ModalService } from './modal.service';
import { MultimodalConfiguratorService } from './multimodal-configurator.service';
import { StoreService } from './store.service';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MultimodalService {

  private currentStepIndexSubject = new BehaviorSubject<number>(0);

  currentStepIndex$ = this.currentStepIndexSubject.asObservable();

  private goBackSubject = new Subject<void>();

  goBack$ = this.goBackSubject.asObservable();

  constructor(
    private storeService: StoreService,
    private modalService: ModalService,
    private multimodalConfiguratorService: MultimodalConfiguratorService
  ) { }

  show(
    group: ModalGroup,
    contentType: ModalContentType,
    isBasic = false,
    item?: DataItem,
    modalConfig?: ModalOptions
  ): BsModalRef {
    if (item) {
      this.storeService.setCurrentDataItem(item);
    } else {
      this.storeService.resetCurrentDataItems();
    }

    const modals: Modal[] = [this.multimodalConfiguratorService.getModalData(group, contentType, isBasic)];

    return this.modalService.show(MultimodalComponent, {
      class: modalConfig && modalConfig.class,
      initialState: { modals }
    });
  }

  showOfferModal(
    group: ModalGroup,
    contentType: ModalContentType,
    isBasic = false
  ): BsModalRef {
    const modals: Modal[] = this.multimodalConfiguratorService.getOfferModals(group, isBasic);
    const currentModalId: string = this.multimodalConfiguratorService.getModalId(group, contentType);

    return this.modalService.show(MultimodalComponent, {
      initialState: { modals, currentModalId }
    });
  }

  showSuccessModal(): any {
    this.show('send-success', 'form', false);
  }

  goBack() {
    this.goBackSubject.next();
  }

  setCurrentStepIndex(stepIndex: number) {
    this.currentStepIndexSubject.next(stepIndex);
  }
}
